import React from "react";
import { compose, graphql } from "react-apollo";

import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { USERS_QUERY } from "./userManagementQueries";
import { CREATE_USER_MUTATION } from "./userManagementMutations";
import UserModal from "./UserModal";

class UserCreate extends React.Component {
  onSave = ({
    name, email, role, password, screenOverrides
  }) => {
    this.props.createUser({
      variables: {
        params: {
          name,
          email,
          role,
          password,
          // The JSON scalar input is parsed from a string server-side.
          screenOverrides: screenOverrides ? JSON.stringify(screenOverrides) : null,
          corporationId: 1,
        }
      },
      refetchQueries: [{
        query: USERS_QUERY
      }]
    })
      .then(() => {
        this.props.snackbarContext.setNotificationTimeOut(Color.success, "Usuário criado.");
        this.props.toggleModal();
      })
      .catch(error => {
        this.props.snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  }

  render() {
    return (
      <UserModal
        isOpen={this.props.isOpen}
        toggleModal={this.props.toggleModal}
        title="Cadastrar usuário"
        onSave={this.onSave}
      />
    );
  }
}

export default compose(
  graphql(CREATE_USER_MUTATION, { name: "createUser", }),
  withSnackbarConsumer,
)(UserCreate);
